import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchPeople } from "../../store/people/actions";
import { setPageTitle } from "../../store/preferences/actions";
import PeopleTable from "../../components/People/PeopleTable";
import queryString from "querystring";
import { fetchGroups } from "../../store/groups/actions";

class People extends Component {
  componentDidMount = () => {
    const {
      userId,
      intl,
      siteLanguage,
      fetchPeople,
      setPageTitle,
      numberOfPeople,
      peoplePage,
      peopleLimit,
      fetchGroups,
    } = this.props;
    const qs = queryString.parse(window.location.search);
    const query = qs["?q"];
    console.log(query);
    fetchPeople(userId, peopleLimit, peoplePage, intl, siteLanguage, query);
    fetchGroups(userId, intl, siteLanguage);
    setPageTitle(
      `${numberOfPeople} ${numberOfPeople === 1 ? "Person" : "People"}`
    );
  };

  componentWillReceiveProps = (newProps) => {
    const {
      userId,
      intl,
      siteLanguage,
      fetchPeople,
      peoplePage,
      peopleLimit,
      location,
    } = this.props;
    const qs = queryString.parse(location.search);
    const newpropsqs = queryString.parse(newProps.location.search);
    if (qs["?q"] !== newpropsqs["?q"]) {
      fetchPeople(
        userId,
        peopleLimit,
        peoplePage,
        intl,
        siteLanguage,
        newpropsqs["?q"]
      );
    }
  };

  render() {
    const {
      fetchingPeople,
      people,
      groups,
      screen,
      fetchingPerson,
      person,
      userId,
      intl,
      siteLanguage,
      numberOfPeople,
      peoplePage,
      peopleLimit,
      fetchPeople,
      peopleFetched,
      uploadPeopleFromFile,
      totalNumberOfPeople,
      location,
      query,
    } = this.props;

    let peopleData = people.map((person, index) => {
      const { Custom, ...rest } = person.data;
      return {
        key: person.uuid,
        ...rest,
        Name:
          (person.data["First Name"] || person.data["First Name "] || "") +
          " " +
          (person.data["Last Name"] || person.data["Last Name "] || ""),
        "GPS Location":
          (person.data["GPS Location"] && person.data["GPS Location"].latitude
            ? person.data["GPS Location"].latitude + ","
            : "") +
          +(person.data["GPS Location"] && person.data["GPS Location"].longitude
            ? person.data["GPS Location"].longitude
            : ""),
        posted_ts: person["posted_ts"],
        align: "center",
      };
    });
    return (
      <React.Fragment>
        <PeopleTable
          query={query}
          groups={groups}
          loading={fetchingPeople}
          people={peopleData}
          screen={screen}
          fetchingPerson={fetchingPerson}
          person={person}
          userId={userId}
          intl={intl}
          siteLanguage={siteLanguage}
          numberOfPeople={numberOfPeople}
          peoplePage={peoplePage}
          peopleLimit={peopleLimit}
          totalNumberOfPeople={totalNumberOfPeople}
          fetchPeople={fetchPeople}
          fetchedPeople={peopleFetched}
          fetchingPeople={fetchingPeople}
          uploadPeopleFromFile={uploadPeopleFromFile}
          location={location}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  siteLanguage: state.intl.siteLanguage,
  isAuthenticated: state.user.isAuthenticated,
  groups: state.groups.groups,
  userId: state.user.userId,
  fetchingPeople: state.people.fetchingPeople,
  fetchingPerson: state.people.fetchingPerson,
  person: state.people.person,
  people: state.people.people,
  query: state.people.query,
  numberOfPeople: state.people.numberOfPeople,
  peoplePage: state.people.peoplePage,
  peopleLimit: state.people.peopleLimit,
  totalNumberOfPeople: state.people.totalNumberOfPeople,
  peopleFetched: state.people.peopleFetched,
});

const mapDispatchToProps = (dispatch) => ({
  fetchPeople: (userId, limit, page, intl, siteLanguage, query) => {
    dispatch(fetchPeople(userId, limit, page, intl, siteLanguage, query));
  },
  setPageTitle: (title) => {
    dispatch(setPageTitle(title));
  },
  fetchGroups: (userId, intl, siteLanguage) => {
    dispatch(fetchGroups(userId, intl, siteLanguage));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(People);
